export const MY_WORK_QUERY_KEY = 'my-work'

export const MY_WORK_IN_PROGRESS_QUERY_KEY = [MY_WORK_QUERY_KEY, 'inProgress']
export const MY_WORK_COMPLETED_QUERY_KEY = [MY_WORK_QUERY_KEY, 'completed']

export const MY_WORK_API_ENDPOINT = 'admin/v1/deliverable-sets/my-works/list'

export const MY_WORK_STALE_TIME = 30 * 1000

export const IN_PROGRESS_STATUSES = ['in_review', 'draft']
export const COMPLETED_STATUSES = ['approved', 'archived']

export const IN_PROGRESS_SORT_BY = '+due_date,+deliverable_set_name'
export const COMPLETED_SORT_BY = '-approved_at,+deliverable_set_name'

export const MY_WORK_DEFAULT_LIMIT = 50
export const MY_WORK_DEFAULT_OFFSET = 0
